document.addEventListener('DOMContentLoaded', function () {
    // We need to get the product variants from a global variable or data attribute
    // Since we are moving this to an external file, we can't use Liquid directly here.
    // We will expect a global variable `productVariants` to be defined in the liquid file before this script runs,
    // OR we can read it from a data attribute on the section.
    // For this refactor, reading from a data attribute is cleaner.

    const productSection = document.querySelector('.product-section');
    if (!productSection) return;

    const productVariants = JSON.parse(productSection.dataset.productVariants || '[]');
    const thumbnails = document.querySelectorAll('.product-thumbnail');
    const mainImage = document.querySelector('.product-main-image img');
    let currentIndex = 0;
    const totalImages = thumbnails.length;

    function updateImage(index) {
        if (index < 0) index = totalImages - 1;
        if (index >= totalImages) index = 0;
        currentIndex = index;

        const thumb = thumbnails[currentIndex];
        if (thumb) {
            const src = thumb.dataset.src;
            if (mainImage) {
                mainImage.src = src;
                mainImage.removeAttribute('srcset'); // Fix: Remove srcset to ensure src update takes effect
            }

            thumbnails.forEach(t => t.classList.remove('active'));
            thumb.classList.add('active');
        }
    }

    thumbnails.forEach((thumb, index) => {
        thumb.addEventListener('click', function () {
            updateImage(index);
        });

        // Preload images
        const src = thumb.dataset.src;
        if (src) {
            const img = new Image();
            img.src = src;
        }
    });

    // Mobile Slider Buttons
    const prevBtn = document.querySelector('.slider-prev');
    const nextBtn = document.querySelector('.slider-next');

    // Use event delegation or direct attachment if elements exist
    if (prevBtn) {
        prevBtn.addEventListener('click', function (e) {
            e.preventDefault(); // Prevent form submission if inside form (it's not, but good practice)
            e.stopPropagation();
            updateImage(currentIndex - 1);
        });
    }

    if (nextBtn) {
        nextBtn.addEventListener('click', function (e) {
            e.preventDefault();
            e.stopPropagation();
            updateImage(currentIndex + 1);
        });
    }

    // Variant Selection Logic
    const variantData = productVariants.map(v => {
        return {
            id: v.id,
            title: v.title,
            options: v.options,
            featured_image: v.featured_image,
            price: v.price,
            compare_at_price: v.compare_at_price
        };
    });

    const variantInputs = document.querySelectorAll('.variant-picker input[type="radio"]');

    function getSelectedOptions() {
        const selected = [];
        document.querySelectorAll('.variant-picker .variant-options').forEach((optionGroup, index) => {
            const checked = optionGroup.querySelector('input:checked');
            if (checked) selected.push(checked.value);
        });
        return selected;
    }

    function updateVariantState() {
        const selectedOptions = getSelectedOptions();
        const matchedVariant = variantData.find(variant => {
            return variant.options.every((option, index) => option === selectedOptions[index]);
        });

        if (matchedVariant) {
            // Update Hidden Input
            const hiddenInput = document.querySelector('.main-product-form input[name="id"]');
            if (hiddenInput) hiddenInput.value = matchedVariant.id;

            // Update Price (Basic implementation)
            const priceSale = document.querySelector('.price-sale');
            if (priceSale) priceSale.textContent = '$' + (matchedVariant.price / 100).toFixed(2); // Simple formatting

            // Update Image
            if (matchedVariant.featured_image) {

                // Better approach: Loop through thumbnails to find a match by Media ID
                let foundIndex = -1;

                thumbnails.forEach((thumb, index) => {
                    if (thumb.dataset.mediaId == matchedVariant.featured_image.id) {
                        foundIndex = index;
                    }
                });

                if (foundIndex !== -1) {
                    updateImage(foundIndex);
                }
            }
        }
    }

    variantInputs.forEach(input => {
        input.addEventListener('change', function () {
            // Update visual state
            const parent = this.closest('.variant-options');
            parent.querySelectorAll('.variant-option-button, .color-swatch').forEach(l => l.classList.remove('selected'));
            this.closest('label').classList.add('selected');

            updateVariantState();
        });
    });

});
